import styled from "styled-components/macro";

export const ComparisonCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  min-height: 160px;
  width: calc(100% - 4em);
  padding: 1em 2em 0.5em 1em;
  margin: 1em 2em;
  background: #ffffff;
  border: 1px solid #dadce0;
  box-sizing: border-box;
  box-shadow: 0px 10px 20px rgba(173, 174, 174, 0.25);
  border-radius: 8px;
`;

export const GroupsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const StyledPropertySelectWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  margin-bottom: 0.7em;
`;
